<div class="container">
  <div class="row">
    <div class="col-12">
      <app-master-donor-table></app-master-donor-table>
    </div>
  </div>
</div>